// extracted by mini-css-extract-plugin
export var background_image = "styles-module--background_image--ac009";
export var square = "styles-module--square--d881e";